module.exports = __webpack_public_path__ + "static/3-2c724eaaea119e5ca890b0490a648a9b.jpg";